<div class="wrapper">
  <button mat-button (click)='goBack()'>Back</button>

  <mat-vertical-stepper [linear]="true" #stepper>
    <mat-step [stepControl]="firstFormGroup" [editable]="false">
      <form [formGroup]="firstFormGroup">
        <ng-template matStepLabel>Fill out your phone</ng-template>
        <mat-form-field appearance="fill">
          <mat-label>Phone number</mat-label>
          <input matInput type="number" formControlName="phone" required>
        </mat-form-field>
        <div>
          <button mat-button matStepperNext [disabled]="loading" (click)='snedResetCode()'>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup" [editable]="false">
      <ng-template matStepLabel>Fill out your code</ng-template>
      <mat-label *ngIf="loading">Please wait...</mat-label>
      <form *ngIf="!loading" [formGroup]="secondFormGroup">
        <mat-label>Code</mat-label>
        <code-input [isCodeHidden]="false" [codeLength]="5" (codeChanged)="onCodeChanged($event)"
          (codeCompleted)="onCodeCompleted($event)" inputmode='none'>
        </code-input>
        <div>
          <!-- <button mat-button matStepperPrevious>Back</button> -->
          <button mat-button style="visibility: hidden; opacity: 0;" matStepperNext id="codebtn">Next</button>
        </div>
      </form>
      <p *ngIf="showerror" style="color: red;">Invalid activation code</p>
    </mat-step>
    <mat-step [editable]="false">
      <ng-template matStepLabel>Change password</ng-template>
      <form [formGroup]="password" class="password-cahnge">
        <input style="margin-top:1em" formControlName="newPass" type='password' placeholder="New password">
        <input style="margin-top:1em" formControlName="confPass" type='password' placeholder="Confirm password">
      </form>
      <div>
        <button mat-button (click)='changePassword()'>Change Password</button>
        <!-- <button mat-button (click)="stepper.reset()">Reset</button> -->
      </div>
    </mat-step>
  </mat-vertical-stepper>

</div>
<app-success *ngIf='successToggle' [text]='message' (ok)='okClick()'></app-success>
